import { render } from "./FAQSection.vue?vue&type=template&id=5a03f4bc&scoped=true"
import script from "./FAQSection.vue?vue&type=script&lang=js"
export * from "./FAQSection.vue?vue&type=script&lang=js"

import "./FAQSection.vue?vue&type=style&index=0&id=5a03f4bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a03f4bc"]])

export default __exports__